module.exports = __webpack_public_path__ + "static/media/technical.9cbc37f8.jpg";